<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title style="padding-left:8px;padding-bottom:8px">
        <span class="headline mb-0">SA接口监控</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search">search</v-btn>
        <v-btn @click="batchReset()">批量重送</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 20, 50, 100, 200]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.creationDatetime }}</td>
          <td>{{ props.item.b2bCallMsgId }}</td>
          <td>{{ props.item.b2bCall }}</td>
          <td>
            <div class="over-content" :title="props.item.b2bCallMsg">
              {{ props.item.b2bCallMsg }}
            </div>
          </td>
          <td>{{ props.item.retryTimes }}</td>
          <td>
            <v-btn @click="resetStatus(props.item.id)">重置状态</v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <!-- <v-dialog v-model="show">
      <v-card class="mt-2">
        <v-card-title>批量更新</v-card-title>
        <v-card-actions>
          <v-btn @click="batchReset">更新</v-btn>
          <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
          <date-picker label="开始日期" v-model="date" />
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      date: null,
      selected: [],
      results: [],
      pagination: {
        rowsPerPage: 10,
      },
      loading: false,
      query: {},
      headers: [
        {
          text: '创建时间',
          value: 'creationDatetime',
          sortable: false,
        },
        {
          text: 'b2b时戳',
          value: 'b2bCallMsgId',
          sortable: false,
        },
        {
          text: '状态',
          value: 'b2bCall',
          sortable: false,
        },
        {
          text: '信息',
          value: 'b2bCallMsg',
          sortable: false,
        },
        {
          text: '重试次数',
          value: 'retryTimes',
          sortable: false,
        },
        {
          text: '操作',
          value: 'operation',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
          sort: 'meta.createAt,desc',
        },
      }
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/monitors/shipments', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    resetStatus(id) {
      this.$http
        .put(`monitors/reset-shipment/${id}`)
        .then(() => {
          this.load()
          this.$message('', '重置成功')
        })
        .catch(() => {
          this.load()
          this.$message('', '重置失败')
        })
    },
    batchReset() {
      Promise.all(
        this.selected.map((s) => {
          return this.$http.put(`monitors/reset-shipment/${s.id}`)
        })
      )
        .then(() => {
          this.load()
          this.$message('', '重置成功')
        })
        .catch(() => {
          this.load()
          this.$message('', '重置失败')
        })
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
